import React, { useState } from "react";

import { InputGroup, Label, Button, Intent } from "@blueprintjs/core";
import PasswordInput from "../form/PasswordInput";
import TermsAndConditions from "../form/TermsAndConditions";
import api from "../common/lib/api";
import { useError } from "../common/components/Errors";
import { Redirect } from "react-router-dom";
import formFieldHelper from "../form/formFieldHelper";
import formErrorHelper from "../form/formErrorHelper";

export default function Page() {
  const [state, setState] = useState({});

  const { errors, setErrors } = useError();
  const [redirect, setRedirect] = useState(false);

  const formField = formFieldHelper(state, setState);
  const formError = formErrorHelper(errors);

  async function submit() {
    setErrors([]);
    const { data } = await api.post("/registration/request", state, {
      validateStatus: () => true,
    });
    if (data.errors) {
      setErrors(data.errors);
      return;
    }
    if (data.registrationToken) {
      setRedirect("/web/register/verify/" + data.registrationToken);
      return;
    }
    console.log(data);
  }

  if (redirect) {
    return <Redirect to={redirect} />;
  }

  return (
    <>
      <h1>Register A New Account</h1>
      <p>Please enter the following details to register a new account.</p>
      <form
        onSubmit={(e) => {
          submit(e.preventDefault());
        }}
      >
        <Label>
          <strong>Please enter a name for the account:</strong>
          <InputGroup
            placeholder="First name"
            type="text"
            required
            {...formField("firstName")}
          />
          {formError("firstName")}
          <InputGroup
            placeholder="Last name"
            type="text"
            required
            {...formField("lastName")}
          />
          {formError("lastName")}
        </Label>
        <Label>
          <strong>
            Please enter a email address to uniquely identify the account:
          </strong>
          <InputGroup
            placeholder="Email"
            type="email"
            required
            {...formField("email")}
          />
          {formError("email")}
        </Label>
        <Label>
          <strong>Please enter a password for the account password:</strong>
          <PasswordInput
            placeholder="Password"
            required
            {...formField("password")}
          />
          {formError("password")}
          <PasswordInput
            placeholder="Repeat password"
            required
            {...formField("confirmPassword")}
          />
          {formError("confirmPassword")}
        </Label>

        <p>
          <strong>
            Please review and accept privacy policy and usage terms and conditions:
          </strong>
        </p>

        <TermsAndConditions
          required
          {...formField("acceptTermsAndConditions")}
        />

        {formError("acceptTermsAndConditions")}

        <Label>
          <strong>
            Please enter a mobile phone number to verify the account:
          </strong>
          <InputGroup
            placeholder="Mobile"
            type="phone"
            required
            {...formField("mobile")}
          />
          {formError("mobile")}
        </Label>
        <p>
          <Button intent={Intent.SUCCESS} type="submit">
            Verify SMS
          </Button>
          {formError("form")}
        </p>
      </form>
    </>
  );
}
